import Photo from "./Photo";
import { useFetchPhotosQuery } from "../store";

const PhotosList = ({ album }) => {
  // console.log(useFetchPhotosQuery(album));
  const { isLoading, isError, data } = useFetchPhotosQuery(album);

  let content;
  if (isLoading) {
    content = "...";
  } else if (isError) {
    content = "Error fetching";
  } else {
    content = data.map((photo) => {
      return <Photo key={photo.id}>{photo}</Photo>;
    });
  }

  return (
    <div className="flex flex-row flex-wrap justify-center mt-2 pb-4 mb-2 border-gray border-b-2">
      {/* Photos */}
      {/* <Photo></Photo>
      <Photo></Photo> */}
      {content}
    </div>
  );
};

export default PhotosList;
